import React, { useEffect, useState } from "react";
import PageLoader from "../../common/pageLoader";
import ManageUsersComponent from "./manageUsers";
import { manageUsers } from "../../../../redux/slice/manageUsersSlice";
import { Cookies } from "react-cookie";
import { connect } from "react-redux";
import { Tag, Button } from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import { userRoleSwitch } from "../../../../redux/slice/userRoleSwitchSlice";
import Notify from "../../common/notify/notify";
import { userDelete } from "../../../../redux/slice/userDeleteSlice";
import { userRoleDelete } from "../../../../redux/slice/userRoleDeleteSlice";
import { MdLockReset } from "react-icons/md";
import { resetUserPin } from "../../../../redux/slice/resetUserPinSlice";
import { societyWingList } from "../../../../redux/slice/societyWingListSlice";

const ManageUsers = (props) => {
  const {
    callmanageUsersData,
    manageUsersData,
    calluserRoleSwitchData,
    calluserDeleteData,
    callresetUserPinData,
    callsocietyWingListData,
    societyWingListData,
    calluserRoleDeleteData,
  } = props;

  const cookies = new Cookies();
  const id = cookies.get("societyId");
  const authToken = cookies.get("authToken");
  const loading = manageUsersData.isLoading;

  const [rangeValue, setRangeValue] = useState([null, null]);
  const [selectedRoles, setSelectedRoles] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [selectedWingId, setSelectedWingId] = useState(null);
  const [confirmRoleModal, setConfirmRoleModal] = useState(false);
  const [confirmDeleteModal, setConfirmDeleteModal] = useState(false);
  const [resetPinModal, setResetPinModal] = useState(false);
  const [newPin, setNewPin] = useState("");
  const [confirmPin, setConfirmPin] = useState("");
  const [selectedWing, setSelectedWing] = useState(null);

  const [infoModalVisible, setInfoModalVisible] = useState(false);
  const [selectedUserForInfo, setSelectedUserForInfo] = useState(null);

  const [filters, setFilters] = useState({
    role: null,
    status: null,
    startDate: null,
    endDate: null,
  });

  useEffect(() => {
    callsocietyWingListData(id);
  }, [id]);

  const wingList = societyWingListData?.societyWingListData?.data?.data || [];

  const handleWingChange = (value) => {
    setSelectedWingId(value);
  };

  useEffect(() => {
    if (id && filters) {
      callmanageUsersData({
        id,
        filters,
      });
    }
  }, [id, filters]);

  const handleClearFilters = () => {
    setFilters({
      role: null,
      status: null,
      startDate: null,
      endDate: null,
    });
    setRangeValue([null, null]);
    setSearchText("");
    setSelectedWingId(null);
  };

  const userDataList = manageUsersData?.manageUsersData?.data?.data;

  const handleRoleChange = (value) => {
    setFilters((prev) => ({ ...prev, role: value }));
  };

  const handleStatusChange = (value) => {
    setFilters((prev) => ({ ...prev, status: value }));
  };

  const handleDateChange = (dates, dateStrings) => {
    setFilters({
      ...filters,
      startDate: dateStrings[0],
      endDate: dateStrings[1],
    });
    setRangeValue(dates);
  };

  const handleShowInfo = (userId) => {
    const user = userDataList.find((u) => u._id === userId);
    if (user) {
      setSelectedUserForInfo(user);
      setInfoModalVisible(true);
    } else {
      Notify(
        "error",
        "User details could not be found. Please check your information and try again.",
        ""
      );
    }
  };

  const user_table_columns = [
    {
      title: "Sr. No.",
      dataIndex: "key",
      key: "key",
      render: (text) => (
        <span>{text ? text.toString().padStart(2, "0") : "00"}</span>
      ),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (name) =>
        name
          ? name
              .split(" ")
              .map(
                (word) =>
                  word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
              )
              .join(" ")
          : "",
    },
    {
      title: "Phone Number",
      dataIndex: "phone_number",
      key: "phone_number",
    },
    {
      title: "Join Date",
      dataIndex: "joinDate",
      key: "joinDate",
    },
    {
      title: "Role",
      dataIndex: "role",
      key: "role",
      render: (role) => {
        if (!role) return "";
        return role
          .replace(/_/g, " ")
          .split(" ")
          .map((word) =>
            word
              .split("/")
              .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
              .join("/")
          )
          .join(" ");
      },
    },
    {
      title: "Wing",
      dataIndex: "wings",
      key: "wings",
      render: (priority) =>
        priority
          ? priority.charAt(0).toUpperCase() + priority.slice(1).toLowerCase()
          : "",
    },
    {
      title: "Flat Number",
      dataIndex: "flat_no",
      key: "flat_no",
    },
    {
      title: "Actions",
      key: "actions",
      render: (text, record) => (
        <div className="edit-delete">
          <Button
            icon={<MdLockReset />}
            style={{ marginRight: 8 }}
            onClick={() => {
              setSelectedUser(record);
              setResetPinModal(true);
            }}
          />
          <Button
            icon={<EditOutlined />}
            style={{ marginRight: 8 }}
            onClick={() => {
              setSelectedUser(record);
              handleChangeRole();
            }}
            disabled={
              !record.flat_no ||
              record.flat_no === "N/a" ||
              ["president", "president/owner"].includes(record.role)
            }
          />
          <Button
            icon={<DeleteOutlined />}
            style={{ marginRight: 8 }}
            onClick={() => {
              setSelectedUser(record);
              handleuserDelete();
            }}
            disabled={["president", "president/owner"].includes(record.role)}
          />
          <Button
            icon={<InfoCircleOutlined />}
            style={{ marginRight: 8 }}
            onClick={() => handleShowInfo(record.id)}
          />
        </div>
      ),
    },
  ];

  const filteredData = userDataList
    ?.filter((item) => {
      const name = (item?.name || "").toLowerCase();
      const phone = (item?.phone_number || "").toString().toLowerCase();
      const search = searchText.toLowerCase();
      const matchesSearch = name.includes(search) || phone.includes(search);
      const matchesWing = selectedWingId
        ? item.assignments?.some((a) => a.wing_id === selectedWingId)
        : true;
      return matchesSearch && matchesWing;
    })
    ?.map((item, index) => ({
      key: index + 1,
      id: item?._id,
      name: item?.name || "N/a",
      user_id: item?.user_id || "N/a",
      phone_number: item?.phone_number || "N/a",
      joinDate: new Date(item.createdAt)?.toLocaleDateString("en-GB") || "N/a",
      wings: item?.assignments[0]?.wing || "N/a",
      wing_id: item?.assignments[0]?.wing_id || "N/a",
      flat_no: item?.assignments[0]?.flat || "N/a",
      flat_id: item?.assignments[0]?.flat_id || "N/a",
      role: item?.assignments[0]?.roles.join(" , ") || "N/a",
      roles: item?.assignments || "N/a",
    }));

  useEffect(() => {
    if (selectedUser) {
      setSelectedRoles(selectedUser.role ? selectedUser.role.split("/") : []);
    }
  }, [selectedUser]);

  const handleConfirmRole = async () => {
    if (
      !selectedUser?.user_id ||
      !selectedUser.wing_id ||
      !selectedUser.flat_id
    ) {
      Notify(
        "error",
        "User details are incomplete. Please check and try again.",
        ""
      );
      return;
    }

    try {
      const result = await calluserRoleSwitchData({
        user_id: selectedUser.user_id,
        society: id,
        wing: selectedUser.wing_id,
        flat: selectedUser.flat_id,
        role: selectedRoles,
      });

      if (result.type === "userRoleSwitch/fulfilled") {
        Notify("success", "The role has been updated successfully.", "");
        setConfirmRoleModal(false);
        await callmanageUsersData({ id, filters });
      } else {
        Notify("error", result.error.message, "");
      }
    } catch (error) {
      Notify(
        "error",
        "Oops! Something went wrong. Please try again later.",
        ""
      );
    }
  };

  const handleChangeRole = () => setConfirmRoleModal(true);
  const handleuserDelete = () => setConfirmDeleteModal(true);

  const handleConfirmDelete = async (userId) => {
    if (!userId) {
      Notify(
        "error",
        "Oops! Something went wrong. Please try again later.",
        ""
      );
      return;
    }
    try {
      const result = await calluserDeleteData({ userId, id });
      if (result.type === "userDelete/fulfilled") {
        Notify("success", "The user has been deleted successfully!", "");
        setConfirmDeleteModal(false);
        await callmanageUsersData({ id, filters });
      } else {
        Notify("error", result.error.message || "Failed to delete user.", "");
      }
    } catch (error) {
      Notify(
        "error",
        "Oops! Something went wrong. Please try again later.",
        ""
      );
    }
  };

  const handleDeleteRole = async (roleData) => {
    const societyIdToUse = id;
    if (!societyIdToUse) {
      Notify("error", "Society ID is missing. Cannot delete role.", "");
      return;
    }

    const payload = {
      userId: roleData.userId,
      flatId: roleData.flatId,
      wingId: roleData.wingId,
      societyId: societyIdToUse,
      role: roleData.roles,
    };

    try {
      const result = await calluserRoleDeleteData(payload);

      if (result.type === "userRoleDelete/fulfilled") {
        Notify("success", "The role has been deleted successfully.", "");

        const usersResponse = await callmanageUsersData({
          id: societyIdToUse,
          filters,
        });
        const updatedUsers = usersResponse.payload?.data?.data;

        if (updatedUsers) {
          const updatedSelectedUser = updatedUsers.find(
            (u) => u._id === payload.userId
          );
          if (updatedSelectedUser) {
            setSelectedUserForInfo(updatedSelectedUser);
          } else {
            setInfoModalVisible(false);
          }
        } else {
          setInfoModalVisible(false);
        }
      } else {
        const errorMessage =
          result.payload?.message ||
          result.error?.message ||
          "Failed to delete role.";
        Notify("error", errorMessage, "");
      }
    } catch (error) {
      Notify(
        "error",
        "Oops! Something went wrong. Please try again later.",
        ""
      );
    }
  };

  const handleConfirmResetPin = async () => {
    if (!newPin || newPin.length < 4) {
      Notify("error", "New PIN must be at least 4 characters long.", "");
      return;
    }
    if (newPin !== confirmPin) {
      Notify(
        "error",
        "New PIN and confirm PIN do not match. Please try again.",
        ""
      );
      return;
    }
    if (!selectedUser?.user_id) {
      Notify(
        "error",
        "Selected user’s phone number is required but missing. Please enter the phone number.",
        ""
      );
      return;
    }

    const payload = {
      user_id: selectedUser.user_id,
      code: newPin,
    };

    try {
      const result = await callresetUserPinData(payload);
      if (result.type === "resetUserPin/fulfilled") {
        Notify("success", "The PIN has been reset successfully!", "");
        setResetPinModal(false);
        setNewPin("");
        setConfirmPin("");
      } else {
        Notify("error", result.error?.message || "Failed to reset pin.", "");
      }
    } catch (error) {
      Notify(
        "error",
        "Oops! Something went wrong. Please try again later.",
        ""
      );
    }
  };

  const isFiltered =
    filters.role ||
    filters.status ||
    filters.startDate ||
    filters.endDate ||
    searchText ||
    selectedWingId;

  return (
    <>
      {loading && <PageLoader />}
      <ManageUsersComponent
        callmanageUsersData={callmanageUsersData}
        manageUsersData={manageUsersData}
        user_table_columns={user_table_columns}
        userDataList={userDataList}
        handleRoleChange={handleRoleChange}
        handleStatusChange={handleStatusChange}
        handleDateChange={handleDateChange}
        handleClearFilters={handleClearFilters}
        filters={filters}
        rangeValue={rangeValue}
        selectedRoles={selectedRoles}
        setSelectedRoles={setSelectedRoles}
        handleChangeRole={handleChangeRole}
        handleuserDelete={handleuserDelete}
        confirmRoleModal={confirmRoleModal}
        setConfirmRoleModal={setConfirmRoleModal}
        confirmDeleteModal={confirmDeleteModal}
        setConfirmDeleteModal={setConfirmDeleteModal}
        selectedUser={selectedUser}
        handleConfirmRole={handleConfirmRole}
        handleConfirmDelete={handleConfirmDelete}
        filteredData={filteredData}
        searchText={searchText}
        setSearchText={setSearchText}
        resetPinModal={resetPinModal}
        setResetPinModal={setResetPinModal}
        newPin={newPin}
        setNewPin={setNewPin}
        confirmPin={confirmPin}
        setConfirmPin={setConfirmPin}
        handleConfirmResetPin={handleConfirmResetPin}
        handleWingChange={handleWingChange}
        selectedWingId={selectedWingId}
        wingList={wingList}
        infoModalVisible={infoModalVisible}
        setInfoModalVisible={setInfoModalVisible}
        selectedUserForInfo={selectedUserForInfo}
        handleDeleteRole={handleDeleteRole}
        isFiltered={isFiltered}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  manageUsersData: state.manageUsersData,
  userDeleteData: state.userDeleteData,
  resetUserPinData: state.resetUserPinData,
  societyWingListData: state.societyWingListData,
  userRoleDeleteData: state.userRoleDeleteData,
});

const mapDispatchToProps = (dispatch) => ({
  callsocietyWingListData: (data) => dispatch(societyWingList(data)),
  callmanageUsersData: (data) => dispatch(manageUsers(data)),
  calluserRoleSwitchData: (data) => dispatch(userRoleSwitch(data)),
  calluserDeleteData: (data) => dispatch(userDelete(data)),
  callresetUserPinData: (data) => dispatch(resetUserPin(data)),
  calluserRoleDeleteData: (data) => dispatch(userRoleDelete(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ManageUsers);
